<template>
  <div class="box">
    <div class="main">
      <ul>
        <li class="upload_img">
          <div class="logo">
            <b>上传公司logo：</b>
            <!-- <el-upload
              class="avatar-uploader"
              :action="upLoad()"
              :show-file-list="false"
              :data="logo"
              :name="name"
              :with-credentials="true"
              :on-success="handleLogo"
            >
              <img v-if="imgLogo" :src="imgLogo" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload> -->
            <div class="u">
              <input type="file" accept="image/*" style="display: none;" id="fileElem" @change="handleFiles">
              <img v-show="imgLogo" :src="imgLogo" class="avatar fileSelect">
              <i v-show="!imgLogo" class="el-icon-plus avatar-uploader-icon fileSelect" :class="icon ? 'el-icon-loading' : ''"></i>
            </div>
          </div>
        </li>
        <li>
          <div class="license">
            <div>
              <h4>上传营业执照或者带有企业名称的办公环境照片</h4>
              <!-- <el-upload
                class="avatar-uploader"
                :action="upLoad()"
                :show-file-list="false"
                :data="license"
                :name="name"
                :with-credentials="true"
                :on-success="handleLicense"
              >
                <img v-if="imgLicense" :src="imgLicense" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload> -->
              <div class="u">
                <input type="file" accept="image/*" style="display: none;" id="fileElem1" @change="handleFiles1">
                <img v-show="imgLicense" :src="imgLicense" class="avatar fileSelect1">
                <i v-show="!imgLicense" class="el-icon-plus avatar-uploader-icon fileSelect1" :class="icon1 ? 'el-icon-loading' : ''"></i>
              </div>
            </div>
            <div>
              <h4>示例</h4>
              <img src="../../assets/img/license.jpg" alt class="example">
            </div>
            <div class="know">
              <h4>上传营业执照或者带有企业名称的办公环境照片须知</h4>
              <p class="mt10">
                <i class="el-icon-star-on"></i>营业执照清晰完善,不能裁剪
              </p>
              <p>
                <i class="el-icon-star-on"></i>不支持手机屏幕截图和电脑的翻拍照片
              </p>
              <p>
                <i class="el-icon-star-on"></i>营业执照的黑白复印件、扫描件、需加盖红色公司印章
              </p>
              <p>
                <i class="el-icon-star-on"></i>营业执照二维码能识别出本公司信息
              </p>
              <p>
                <i class="el-icon-star-on"></i>如公司信息已变更,请上传最新营业执照
              </p>
              <p>
                <i class="el-icon-star-on"></i>营业执照与公司全称一致
              </p>
              <p>
                <i class="el-icon-star-on"></i>如添加水印须与拉勾网招聘审核相关
              </p>
            </div>
          </div>
        </li>
      </ul>
      <div class="next">
        <el-button type="primary" @click="back">上一步</el-button>
        <el-button type="primary" @click="next">下一步</el-button>
        <!-- <el-button type="primary" @click="next" v-if="cooperation_school && !icon && !icon1">下一步</el-button> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import baseUrl from '../../api/baseUrl';
import axios from 'axios';

export default {
  data() {
    return {
      id: localStorage.getItem('id'),
      cooperation_school_list: [],
      cooperation_school: '',
      is_invited: false,
      name: 'photo',
      imgLogo: '',
      imgLicense: '',
      logo: {
        type: 'logo_image'
      },
      license: {
        type: 'bl_image'
      },
      icon: false,
      icon1: false
    };
  },
  computed: {
    ...mapState(['register'])
  },
  mounted() {
    this.get_school_list();
    this.getLicense();
    this.getLogo();

    var fileSelect0 = document.getElementsByClassName('fileSelect')[0],
      fileSelect1 = document.getElementsByClassName('fileSelect')[1],
      fileElem = document.getElementById('fileElem');

    fileSelect0.addEventListener(
      'click',
      function(e) {
        if (fileElem) {
          fileElem.click(); // jQuery可以使用 trigger()
        }
        e.preventDefault(); // prevent navigation to "#"
      },
      false
    );
    fileSelect1.addEventListener(
      'click',
      function(e) {
        if (fileElem) {
          fileElem.click(); // jQuery可以使用 trigger()
        }
        e.preventDefault(); // prevent navigation to "#"
      },
      false
    );

    var f0 = document.getElementsByClassName('fileSelect1')[0],
      f1 = document.getElementsByClassName('fileSelect1')[1],
      fm = document.getElementById('fileElem1');

    f0.addEventListener(
      'click',
      function(e) {
        if (fm) {
          fm.click(); // jQuery可以使用 trigger()
        }
        e.preventDefault(); // prevent navigation to "#"
      },
      false
    );
    f1.addEventListener(
      'click',
      function(e) {
        if (fm) {
          fm.click(); // jQuery可以使用 trigger()
        }
        e.preventDefault(); // prevent navigation to "#"
      },
      false
    );
  },
  methods: {
    async get_school_list() {
      let res = await this.$api.school.getSchool(1, 100);
      if (res.code === 0) {
        this.cooperation_school_list = res.data.items;
      }
    },
    async getLicense() {
      let res = await this.$api.info.getLicense();
      if (res.code === 0) {
        this.imgLicense = res.data;
      }
    },
    async getLogo() {
      let res = await this.$api.info.getLogo();
      if (res.code === 0 && res.data) {
        this.imgLogo = res.data;
      }
    },
    upLoad() {
      var url = baseUrl + 'api/enterprise/business/pic/add'; // 生产环境和开发环境的判断
      return url;
    },
    edit() {
      this.$emit('reduceActive');
    },
    handleLogo(res, file) {
      this.imgLogo = URL.createObjectURL(file.raw);
    },
    handleLicense(res, file) {
      this.imgLicense = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 10;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 10MB!');
      }
      return isJPG && isLt2M;
    },
    // 下一步
    async next() {
      if (this.imgLicense == '') {
        this.$message('为提高审核效率，请尽快上传营业执照或者带有企业名称的办公环境照片！');
      }
      // if (this.cooperation_school) {
      //   let params = {
      //     school_id: this.cooperation_school,
      //     source: 'enterprise',
      //   }
      //   let res = await this.$api.school.applyAdd(params)
      //   if (res.code !== 0) {
      //     this.$message.error(res.msg)
      //     return
      //   }
      //   localStorage.setItem('relationId', res.data.id)
      //   localStorage.setItem('cooperationSchoolId', res.data.school_id)

      // }
      this.$emit('changeActive');
    },
    back() {
      this.$emit('reduceActive');
    },
    // 上传logo
    handleFiles(e) {
      if (e.target.files.length === 0) {
        return;
      }
      this.imgLogo = '';
      this.icon = true;
      let that = this;
      var file = e.target.files[0]; //获取图片资源
      let maxSize = 2 * 1024 * 1204;
      let fileInput = document.getElementById('fileElem');

      // 只选择图片文件
      if (!file.type.match('image.*')) {
        this.$message.error('请上传图片！');
        fileInput.value = '';
        return false;
      }

      if (file.size > 6 * 1024 * 1024) {
        this.$message.error('图片大小不能超过6M！');
        fileInput.value = '';
        return;
      }

      var reader = new FileReader();
      reader.readAsDataURL(file); // 读取文件

      reader.onload = function() {
        if (file.size <= maxSize) {
          that.uploadLicense(file, this.result);
        } else {
          console.log(1);
          var result = this.result;
          let img = new Image();
          img.src = result;

          img.onload = function() {
            var canvas = document.createElement('canvas');
            let ctx = canvas.getContext('2d');
            canvas.width = 300;
            canvas.height = 300;
            ctx.drawImage(this, 0, 0, 300, 300);
            canvas.toBlob(function(blob) {
              let fileData = new window.File([blob], file.name, { type: file.type });
              that.uploadLicense(fileData, result);
            });
          };
        }
      };
    },
    async uploadLicense(fileData, base64) {
      // let fileData = document.getElementById("fileElem").files[0]
      // console.log(fileData)
      let formData = new FormData();
      formData.append('photo', fileData);
      formData.append('type', 'logo_image');

      try {
        let res = await axios.post(baseUrl + 'api/enterprise/business/pic/add', formData, {
          withCredentials: true
        });

        if (res.data.code === 0) {
          this.imgLogo = base64;
          this.$message.success('上传成功');
        } else {
          this.getLogo();
          this.$message.error(res.data.msg);
        }
      } catch (error) {
        this.$message.error(error.message);
        this.getLogo();
      } finally {
        this.icon = false;
      }
    },
    handleFiles1(e) {
      if (e.target.files.length === 0) {
        return;
      }
      this.imgLicense = '';
      this.icon1 = true;
      let that = this;
      var file = e.target.files[0]; //获取图片资源
      let maxSize = 2 * 1024 * 1204;
      let fileInput = document.getElementById('fileElem1');

      // 只选择图片文件
      if (!file.type.match('image.*')) {
        this.$message.error('请上传图片！');
        fileInput.value = '';
        return false;
      }

      if (file.size > 6 * 1024 * 1024) {
        this.$message.error('图片大小不能超过6M！');
        fileInput.value = '';
        return;
      }

      var reader = new FileReader();
      reader.readAsDataURL(file); // 读取文件

      reader.onload = function() {
        if (file.size <= maxSize) {
          that.uploadLicense1(file, this.result);
        } else {
          console.log(1);
          var result = this.result;
          let img = new Image();
          img.src = result;

          img.onload = function() {
            var canvas = document.createElement('canvas');
            let ctx = canvas.getContext('2d');
            canvas.width = 300;
            canvas.height = 300;
            ctx.drawImage(this, 0, 0, 300, 300);
            canvas.toBlob(function(blob) {
              let fileData = new window.File([blob], file.name, { type: file.type });
              that.uploadLicense1(fileData, result);
            });
          };
        }
      };
    },
    async uploadLicense1(fileData, base64) {
      // let fileData = document.getElementById("fileElem").files[0]
      // console.log(fileData)
      let formData = new FormData();
      formData.append('photo', fileData);
      formData.append('type', 'bl_image');

      try {
        let res = await axios.post(baseUrl + 'api/enterprise/business/pic/add', formData, {
          withCredentials: true
        });

        if (res.data.code === 0) {
          this.imgLicense = base64;
          this.$message.success('上传成功');
        } else {
          this.getLicense();
          this.$message.error(res.data.msg);
        }
      } catch (error) {
        this.$message.error(error.message);
        this.getLicense();
      } finally {
        this.icon1 = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.box {
  margin: 0 auto;
  width: 100%;
  color: #333;
  h3 {
    margin: 10px 0 40px 0;
    font-size: 20px;
    font-weight: 700;
    text-align: center;
  }
  .img {
    text-align: center;
    img {
      width: 150px;
      height: 150px;
    }
  }
  .main {
    background: #fff;
    padding: 20px 50px;
    li {
      border: 1px solid #ddd;
      border-radius: 5px;
      padding: 10px;
      margin: 25px 0;
      b {
        font-weight: bold;
      }
      .edit {
        color: #409eff;
        cursor: pointer;
      }
    }
    .en_info {
      .info {
        border-bottom: 1px solid #ddd;
        margin-bottom: 20px;
      }
      span {
        display: inline-block;
        width: 50%;
        margin-bottom: 20px;
      }
    }
    .upload_img {
      display: flex;
      .logo {
        margin-right: 100px;
      }
    }
    .license {
      overflow: hidden;
      div {
        float: left;
        margin-right: 20px;
        .example {
          width: 100px;
          height: 150px;
          margin-top: 20px;
        }
        h4 {
          font-weight: bold;
        }
      }
      div.know {
        margin-top: 40px;
        p {
          line-height: 18px;
          color: #999;
          font-size: 12px;
        }
      }
    }
    .next {
      text-align: center;
      margin-top: 35px;
    }
    .avatar-uploader {
      margin-top: 20px;
      text-align: left;
      .el-upload {
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        &:hover {
          border-color: #409eff;
        }
      }
      .avatar-uploader-icon {
        border: 1px dashed #d9d9d9;
        font-size: 28px;
        color: #8c939d;
        width: 120px;
        height: 150px;
        line-height: 150px;
        text-align: center;
      }
      .avatar {
        width: 120px;
        height: 150px;
        display: block;
      }
    }
  }
}
.u {
  width: 120px;
  height: 150px;
  border: 1px dashed #ccc;
  margin-top: 20px;
  text-align: center;
  line-height: 160px;
  font-size: 30px;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>